<section class="top-section">
  <div class="container">
    <h1>{{'FOOTER.TERMS' | translate}}</h1>

    <ng-container *ngIf="activeTab === ACTIVE_TAB.GIPANT && currentLang === 'no'">
      <p class="last-update">Sist oppdatert: Januar 2026 · Versjon 1.3</p>

      <div class="content" data-header-contrast="light">
        <h2>1. Innledning</h2>
        <p>Disse vilkårene regulerer bruken av Gi Pant-appen for givere som ønsker å bestille henting av pant. Ved å bruke tjenesten godtar du disse vilkårene.</p>
        <p>Gi Pant AS leverer en digital plattform som kobler givere og registrerte lag/spillere. Gi Pant AS henter ikke pant selv.</p>

        <h2>2. Roller</h2>
        <ul>
          <li><p><strong>Giver</strong> – personen som bestiller henting</p></li>
          <li><p><strong>Spiller</strong> – personen som henter panten</p></li>
          <li><p><strong>Foresatt</strong> – ansvarlig for barn under 15 år</p></li>
          <li><p><strong>Lagadministrator</strong> – ansvarlig for laget</p></li>
        </ul>

        <h2>3. Bestilling av henting</h2>
        <p>Når du bestiller henting:</p>
        <ul>
          <li><p>Du får tildelt nærmeste tilgjengelige spiller basert på geografisk avstand</p></li>
          <li><p>Du forplikter deg til å sette panten på avtalt sted</p></li>
          <li><p>Du mottar oppdateringer når spilleren aksepterer og når henting fullføres</p></li>
        </ul>

        <h2>4. Eierskap til pant</h2>
        <ul>
          <li><p><strong>Før henting:</strong> giver eier panten</p></li>
          <li><p><strong>Etter fysisk henting:</strong> panten overføres til laget/spilleren</p></li>
          <li><p><strong>Gi Pant AS</strong> eier aldri pant</p></li>
        </ul>

        <h2>5. Hva du kan levere</h2>
        <p>Tillatt:</p>
        <ul>
          <li><p>Tomflasker og bokser med gyldig pantemerke</p></li>
          <li><p>Panten må være i poser, lukket og klar til henting</p></li>
        </ul>
        <p>Forbudt:</p>
        <ul>
          <li><p>Søppel (plast, matavfall, papp, metall, elektronikk)</p></li>
          <li><p>Glass som ikke er pant</p></li>
          <li><p>Farlig avfall</p></li>
        </ul>
        <p><strong>⚠️ Levering av farlig avfall kan føre til umiddelbar blokkering av giverkonto.</strong></p>

        <h2>6. Hva skjer hvis laget ikke kommer?</h2>
        <p>Dersom hentingen ikke utføres innen rimelig tid:</p>
        <ul>
          <li><p>Oppdraget sendes automatisk videre til neste tilgjengelige spiller</p></li>
          <li><p>Gi Pant AS er kun plattformformidler og kan ikke holdes ansvarlig for manglende oppmøte</p></li>
        </ul>

        <h2>7. Personvern</h2>
        <ul>
          <li><p>Gi Pant lagrer kun nødvendig informasjon (navn, adresse, ordrelogg)</p></li>
          <li><p>GPS-data brukes ikke for givere</p></li>
          <li><p>Full informasjon finnes i <a href="/{{currentLang}}/henter-pant/privacy-policy">Personvernerklæring v1.2</a></p></li>
        </ul>

        <h2>8. Feil i poser</h2>
        <p>Hvis spilleren finner:</p>
        <ul>
          <li><p>søppel</p></li>
          <li><p>farlig avfall</p></li>
          <li><p>glass som ikke er pant</p></li>
          <li><p>poser som ikke er satt ut</p></li>
        </ul>
        <p>…kan laget:</p>
        <ul>
          <li><p>rapportere forholdet</p></li>
          <li><p>markere ordren som «Feil»</p></li>
          <li><p>i alvorlige tilfeller be om utestengelse av giver</p></li>
        </ul>
        <p>Ved gjentatte brudd kan giver blokkeres.</p>

        <h2>9. Sikkerhet og oppførsel</h2>
        <p>Du forplikter deg til å:</p>
        <ul>
          <li><p>opptre høflig</p></li>
          <li><p>ikke utsette spillere for fare</p></li>
          <li><p>plassere posene tilgjengelig og trygt</p></li>
          <li><p>unngå kommunikasjon som kan oppfattes som truende</p></li>
        </ul>

        <h2>10. Misbruk og utestengelse</h2>
        <p>Gi Pant AS kan blokkere eller suspendere giver ved:</p>
        <ul>
          <li><p>levering av farlig avfall</p></li>
          <li><p>trusler eller trakassering</p></li>
          <li><p>gjentatt feilplassering av poser</p></li>
          <li><p>misbruk av tjenesten</p></li>
        </ul>

        <h2>11. Ansvarsbegrensning</h2>
        <p>Gi Pant AS er ikke ansvarlig for:</p>
        <ul>
          <li><p>at spillere ikke møter</p></li>
          <li><p>skader som følge av håndtering av poser</p></li>
          <li><p>feilsortering av poser</p></li>
          <li><p>tap av pant etter at posene er hentet</p></li>
        </ul>

        <h2>12. Bruk av lag- og foreningsinformasjon</h2>
        <p>Gi Pant viser navn og logo til lag og foreninger utelukkende som en del av tjenestens funksjonalitet, herunder for å identifisere hvilket lag eller hvilken forening en donasjon går til.</p>
        <p>Gi Pant AS benytter ikke lag eller foreningers navn, logo eller visuelle kjennetegn i ekstern markedsføring, presentasjoner eller som referansekunder, med mindre dette er særskilt avtalt skriftlig.</p>

        <h2>13. Endringer i vilkår</h2>
        <p>Gi Pant AS kan oppdatere vilkårene ved behov.</p>
        <p>Vesentlige endringer varsles i appen.</p>

        <h2>14. Verneting</h2>
        <p>Norsk rett gjelder.</p>
        <p>Verneting: <strong>Salten og Lofoten tingrett.</strong></p>

        <h3 class="mt-5"><a href="../../../assets/legal/Terms-of-Use_Vilkar-for-bruk-GiPant.pdf" download>Last ned fullstendig versjon av vilkårene (PDF)</a></h3>
      </div>
    </ng-container>


    <ng-container *ngIf="activeTab === ACTIVE_TAB.GIPANT && currentLang === 'en'">
      <p class="last-update">Last updated: January 2026 · Version 1.3</p>

      <div class="content" data-header-contrast="light">
        <h2>1. Introduction</h2>
        <p>These terms govern the use of the Gi Pant app for donors who wish to schedule bottle deposit pickups. By using the service, you agree to these terms.</p>
        <p>Gi Pant AS provides a digital platform connecting donors with registered teams and players. Gi Pant AS does not perform bottle pickups itself.</p>

        <h2>2. Roles</h2>
        <ul>
          <li><p><strong>Donor</strong> – the person scheduling a pickup</p></li>
          <li><p><strong>Player</strong> – the person collecting the bottles</p></li>
          <li><p><strong>Guardian</strong> – responsible for children under 15</p></li>
          <li><p><strong>Team administrator</strong> – responsible for the team</p></li>
        </ul>

        <h2>3. Scheduling a pickup</h2>
        <p>When scheduling a pickup:</p>
        <ul>
          <li><p>You are matched with the nearest available player based on geographic proximity</p></li>
          <li><p>You must place the bottles at the agreed location</p></li>
          <li><p>You receive updates when the pickup is accepted and completed</p></li>
        </ul>

        <h2>4. Ownership of deposits</h2>
        <ul>
          <li><p><strong>Before pickup:</strong> the donor owns the bottles</p></li>
          <li><p><strong>After physical pickup:</strong> ownership transfers to the team/player</p></li>
          <li><p><strong>Gi Pant AS</strong> never owns bottle deposits</p></li>
        </ul>

        <h2>5. Accepted items</h2>
        <p>Allowed:</p>
        <ul>
          <li><p>Empty bottles and cans with valid deposit markings</p></li>
          <li><p>Bottles must be bagged, sealed and ready for pickup</p></li>
        </ul>
        <p>Not allowed:</p>
        <ul>
          <li><p>Waste (plastic, food, cardboard, metal, electronics)</p></li>
          <li><p>Non-deposit glass</p></li>
          <li><p>Hazardous waste</p></li>
        </ul>
        <p><strong>⚠️ Hazardous waste may result in immediate account suspension.</strong></p>

        <h2>6. If the pickup is not completed</h2>
        <p>If a pickup is not completed within a reasonable time:</p>
        <ul>
          <li><p>The request is automatically reassigned to the next available player</p></li>
          <li><p>Gi Pant AS acts solely as a platform intermediary and is not liable for no-shows</p></li>
        </ul>

        <h2>7. Privacy</h2>
        <ul>
          <li><p>Gi Pant stores only necessary information (name, address, order logs)</p></li>
          <li><p>GPS data is not used for donors</p></li>
          <li><p>Full details are available in the <a href="/{{currentLang}}/henter-pant/privacy-policy">Privacy Policy v1.2</a></p></li>
        </ul>

        <h2>8. Invalid or incorrect bags</h2>
        <p>If a player encounters:</p>
        <ul>
          <li><p>waste</p></li>
          <li><p>hazardous materials</p></li>
          <li><p>non-deposit glass</p></li>
          <li><p>missing or inaccessible bags</p></li>
        </ul>
        <p>…the team may:</p>
        <ul>
          <li><p>report the issue</p></li>
          <li><p>mark the order as “Invalid”</p></li>
          <li><p>in serious cases, request donor suspension</p></li>
        </ul>
        <p>Repeated violations may lead to account blocking.</p>

        <h2>9. Safety and conduct</h2>
        <p>You agree to:</p>
        <ul>
          <li><p>behave respectfully</p></li>
          <li><p>not expose players to risk</p></li>
          <li><p>place bags safely and accessibly</p></li>
          <li><p>avoid threatening or abusive communication</p></li>
        </ul>

        <h2>10. Misuse and suspension</h2>
        <p>Gi Pant AS may suspend or block donors due to:</p>
        <ul>
          <li><p>hazardous waste</p></li>
          <li><p>threats or harassment</p></li>
          <li><p>repeated incorrect placements</p></li>
          <li><p>misuse of the service</p></li>
        </ul>

        <h2>11. Limitation of liability</h2>
        <p>Gi Pant AS is not liable for:</p>
        <ul>
          <li><p>missed pickups</p></li>
          <li><p>injuries related to bag handling</p></li>
          <li><p>incorrect sorting</p></li>
          <li><p>loss of deposits after pickup</p></li>
        </ul>

        <h2>12. Use of team and organization information</h2>
        <p>Gi Pant displays team and organization names and logos solely as part of the service, including identifying which team a donation supports.</p>
        <p>Gi Pant AS does not use team or organization names, logos or visual identifiers in external marketing, presentations or as customer references unless explicitly agreed in writing.</p>

        <h2>13. Changes to the terms</h2>
        <p>Gi Pant AS may update these terms when necessary.</p>
        <p>Material changes will be notified in the app.</p>

        <h2>14. Governing law and venue</h2>
        <p>Norwegian law applies.</p>
        <p>Venue: Salten and Lofoten District Court.</p>

        <h3 class="mt-5"><a href="../../../assets/legal/Terms-of-Use_Vilkar-for-bruk-GiPant.pdf" download>Download the full version of the terms (PDF)</a></h3>
      </div>
    </ng-container>


    <ng-container *ngIf="activeTab === ACTIVE_TAB.HENTERPANT && currentLang === 'no'">
      <p class="last-update">Sist oppdatert: Januar 2026 · Versjon 1.3</p>

      <div class="content" data-header-contrast="light">
        <h2>1. Innledning</h2>
        <p>Disse vilkårene gjelder for brukere av Henter Pant-appen: lag, klubber, spillere og foresatte. Ved å bruke tjenesten samtykker du til disse vilkårene.</p>
        <p>Gi Pant AS leverer en digital plattform som gjør det mulig for idrettslag og skoleklasser å hente pant som inntektskilde.</p>

        <h2>2. Roller</h2>
        <ul>
          <li>
            <p><strong>2.1 Lag/klubb (betalende kunde)</strong></p>
            <ul>
              <li><p>juridisk avsender av pantinntekter</p></li>
              <li><p>mottar fakturaer</p></li>
              <li><p>har ansvar for at spillere følger gjeldende regler</p></li>
            </ul>
          </li>
          <li>
            <p><strong>2.2 Lagadministrator</strong></p>
            <ul>
              <li><p>oppretter laget</p></li>
              <li><p>inviterer spillere</p></li>
              <li><p>har tilgang til oversikt over ordre, kvitteringer og lagets fremdrift</p></li>
            </ul>
          </li>
          <li>
            <p><strong>2.3 Spiller</strong></p>
            <ul>
              <li><p>henter pant</p></li>
              <li><p>registrerer beløp</p></li>
              <li><p>laster opp kvittering</p></li>
              <li><p>følger sikkerhetsregler</p></li>
              <li><p>bruker adresse (ikke GPS)</p></li>
            </ul>
          </li>
          <li>
            <p><strong>2.4 Foresatt</strong></p>
            <ul>
              <li><p>kreves for spillere under 15 år</p></li>
              <li><p>kontrollerer barnets konto</p></li>
              <li><p>har full innsynsrett</p></li>
              <li><p>kan aktivere/deaktivere GPS for egen enhet</p></li>
            </ul>
          </li>
          <li>
            <p><strong>2.5 Barn</strong></p>
            <ul>
              <li><p>kan ikke ha egen GPS</p></li>
              <li><p>må ha aktiv foresattprofil</p></li>
            </ul>
          </li>
        </ul>

        <h2>3. Abonnement og betaling</h2>
        <ul>
          <li>
            <p><strong>3.1 Første betaling (Nets Easy)</strong></p>
            <ul>
              <li><p>første måned betales via Nets Easy</p></li>
              <li><p>betalingen må være vellykket for å få tilgang</p></li>
              <li><p>mislykket betaling = ingen tilgang</p></li>
            </ul>
          </li>
          <li>
            <p><strong>3.2 Løpende betaling (PowerOffice)</strong></p>
            <ul>
              <li><p>faktureres hver måned</p></li>
              <li><p>inkludert: abonnement, provisjon/royalty og fakturagebyr</p></li>
              <li><p>12 dager betalingsfrist + 30 dager betalingsutsettelse (grace period)</p></li>
            </ul>
          </li>
          <li>
            <p><strong>3.3 Oppsigelsestid</strong></p>
            <ul>
              <li><p>Oppsigelsestiden er tre (3) måneder, regnet fra førstkommende månedsskifte.</p></li>
              <li><p>Abonnementet løper i hele oppsigelsesperioden. Det gis ingen refusjon for påbegynt måned.</p></li>
            </ul>
          </li>
          <li>
            <p><strong>3.4 Avslutning av konto</strong></p>
            <ul>
              <li><p>Gi Pant AS kan suspendere laget ved manglende betaling</p></li>
              <li><p>laget kan ikke kreve tilbakebetaling for perioder som allerede er fakturert</p></li>
            </ul>
          </li>
        </ul>

        <h2>4. Rabatter og invitasjonskoder</h2>
        <ul>
          <li>
            <p><strong>4.1 Invitasjonskoder</strong></p>
            <ul>
              <li><p>lag som inviterer får rabatt</p></li>
              <li><p>nye lag får rabatt</p></li>
              <li><p>rabattsats kan variere</p></li>
              <li><p>rabatt trekkes i PowerOffice på neste faktura</p></li>
            </ul>
          </li>
          <li>
            <p><strong>4.2 Kombinasjon med kampanjekode</strong></p>
            <ul>
              <li><p>invitasjonskode og kampanjekode kan kombineres</p></li>
              <li><p>rabatt vises alltid i appen før kjøp</p></li>
            </ul>
          </li>
        </ul>

        <h2>5. Henting av pant</h2>
        <ul>
          <li>
            <p><strong>5.0 Lagets ansvar</strong></p>
            <p>Laget/klubben/foreningen har et overordnet ansvar for at henting av pant skjer i samsvar med disse vilkårene. Ved mistanke om svindel, manipulering av kvitteringer, misbruk av flasker/pant eller annen uredelig praksis kan Gi Pant AS suspendere hele eller deler av lagets tilgang.</p>
          </li>
          <li>
            <p><strong>5.1 Spillernes ansvar</strong></p>
            <p>Spilleren må:</p>
            <ul>
              <li><p>hente pant på avtalt sted</p></li>
              <li><p>pante posene</p></li>
              <li><p>registrere beløpet</p></li>
              <li><p>laste opp kvittering</p></li>
            </ul>
          </li>
          <li>
            <p><strong>5.2 Feil i kvitteringen</strong></p>
            <ul>
              <li><p>feil beløp markeres med gult flagg</p></li>
              <li><p>ved gjentatte feil kan spilleren suspenderes</p></li>
            </ul>
          </li>
          <li>
            <p><strong>5.3 Hva skjer hvis posene mangler?</strong></p>
            <ul>
              <li><p>ordren markeres som «ikke funnet»</p></li>
              <li><p>laget kan rapportere giveren</p></li>
              <li><p>gjentatte hendelser kan medføre utestengelse av giver</p></li>
            </ul>
          </li>
          <li>
            <p><strong>5.4 Deling av profiler og ordrekommunikasjon</strong></p>
            <p>Henter Pant tilbyr deling av lagprofiler, spillerprofiler og henteordre via sosiale medier, meldingsplattformer og delbare lenker. All slik deling initieres av brukeren. Innhold delt av brukeren kan bli tilgjengelig for tredjepart utenfor Henter Pant sitt kontrollområde, og brukeren er ansvarlig for hvordan innholdet deles. Lagadministrator og foresatt skal veilede spillere og barn i trygg bruk.</p>
          </li>
        </ul>

        <h2>6. GPS og lokasjonsdata</h2>
        <ul>
          <li>
            <p><strong>6.1 Spillere og barn</strong></p>
            <ul>
              <li><p>spores aldri</p></li>
              <li><p>kun adresse benyttes</p></li>
            </ul>
          </li>
          <li>
            <p><strong>6.2 Foresatte</strong></p>
            <ul>
              <li><p>kan velge å aktivere GPS for å motta henteoppdrag</p></li>
              <li><p>GPS gis av telefonens operativsystem (iOS/Android), ikke av appen</p></li>
              <li><p>oppdateringsintervall styres av operativsystemet</p></li>
              <li><p>Gi Pant AS lagrer ikke kontinuerlig GPS-data</p></li>
            </ul>
          </li>
          <li>
            <p><strong>6.3 Sletting av lokasjon</strong></p>
            <ul>
              <li><p>GPS-data slettes etter maks 7 dager</p></li>
            </ul>
          </li>
          <li>
            <p><strong>6.4 Pause-funksjon</strong></p>
            <ul>
              <li><p>stopper all GPS-behandling</p></li>
              <li><p>stopper nye ordre</p></li>
              <li><p>stopper varsler</p></li>
            </ul>
          </li>
        </ul>

        <h2>7. Misbruk, suspensjon og utestengelse</h2>
        <ul>
          <li>
            <p><strong>7.1 Gi Pant AS kan suspendere brukere ved:</strong></p>
            <ul>
              <li><p>feilrapportering av kvitteringer</p></li>
              <li><p>farlig avfall</p></li>
              <li><p>aggressiv eller truende oppførsel</p></li>
              <li><p>teknisk manipulasjon</p></li>
              <li><p>svindelforsøk</p></li>
            </ul>
          </li>
          <li>
            <p><strong>7.2 Lagets ansvar ved mislighold</strong></p>
            <ul>
              <li><p>laget er ansvarlig for sine spillere</p></li>
              <li><p>én spiller kan suspenderes uten at hele laget stenges</p></li>
              <li><p>laget suspenderes kun ved manglende betaling</p></li>
            </ul>
          </li>
          <li>
            <p><strong>7.3 Varighet</strong></p>
            <ul>
              <li><p>suspensjon varer til saken er ferdig undersøkt</p></li>
              <li><p>normalt 7–30 dager</p></li>
            </ul>
          </li>
          <li>
            <p><strong>7.4 Permanent utestengelse</strong></p>
            <p>Ved grovt mislighold:</p>
            <ul>
              <li><p>kontoen stenges permanent</p></li>
              <li><p>spilleren kan ikke opprette ny konto</p></li>
            </ul>
          </li>
        </ul>

        <h2>8. Sikkerhet og ansvar</h2>
        <p>Gi Pant AS er ikke ansvarlig for:</p>
        <ul>
          <li><p>skader spillere pådrar seg under henting</p></li>
          <li><p>innhold i posene</p></li>
          <li><p>farlig avfall levert av givere</p></li>
          <li><p>tap som følge av feilregistrering hos spillere</p></li>
          <li><p>forsinkelser eller kanselleringer av ordre</p></li>
        </ul>

        <h2>9. Personvern</h2>
        <ul>
          <li><p>Full informasjon om behandling av personopplysninger finnes i:</p></li>
          <li><p>📄 <a href="/{{currentLang}}/henter-pant/privacy-policy">Personvernerklæring v1.2</a></p></li>
        </ul>

        <h2>10. E-postkommunikasjon</h2>
        <p>Gi Pant AS benytter e-post som kommunikasjonskanal overfor lag, klubb, forening, lagadministrator og foresatte i den grad det er nødvendig for drift, sikkerhet og bruk av tjenesten.</p>
        <h3>10.1 Tjenesterelatert e-post</h3>
        <p>Kan ikke reserveres mot og omfatter blant annet:</p>
        <ul>
          <li><p>ordre- og statusvarsler</p></li>
          <li><p>kvitteringer og bekreftelser</p></li>
          <li><p>varsler om avvik, suspensjon eller sikkerhet</p></li>
          <li><p>informasjon om endringer i vilkår eller tjenesten</p></li>
          <li><p>faktura og betalingsrelatert kommunikasjon</p></li>
        </ul>
        <h3>10.2 Produktinformasjon og tjenesteutvikling</h3>
        <p>Kan sendes basert på berettiget interesse og inneholder alltid avmeldingsmulighet:</p>
        <ul>
          <li><p>tips og anbefalinger</p></li>
          <li><p>informasjon om nye eller forbedrede funksjoner</p></li>
          <li><p>invitasjoner til pilot, beta eller testing</p></li>
        </ul>
        <h3>10.3 Mottakere og rollefordeling</h3>
        <ul>
          <li><p>lagadministrator mottar e-post knyttet til lagets bruk</p></li>
          <li><p>foresatt er primær mottaker for barn og spillerkontoer</p></li>
          <li><p>spillere mottar normalt ikke direkte e-post i MVP-fasen</p></li>
        </ul>

        <h2>11. Endringer i vilkår</h2>
        <p>Gi Pant AS kan oppdatere disse vilkårene ved behov. Vesentlige endringer vil varsles.</p>

        <h2>12. Verneting og lovvalg</h2>
        <p>Norsk rett gjelder.</p>
        <p>Verneting: Salten og Lofoten tingrett.</p>

        <h2>13. Bruk av navn, logo og visuelle kjennetegn</h2>
        <p>Ved registrering av klubb, lag og/eller forening og/eller kjøp av abonnement i Henter Pant, gir klubben, laget eller foreningen Henter Pant AS et ikke-eksklusivt, vederlagsfritt og tidsubegrenset samtykke til å bruke klubbens, lagets eller foreningens navn, logo og øvrige visuelle kjennetegn ("Logo") i følgende sammenhenger:</p>
        <ul>
          <li><p><strong>a) Bruk i tjenesten:</strong> Visning av lagets/foreningens navn og logo i Henter Pant-appen og tilknyttede flater.</p></li>
          <li><p><strong>b) Markedsføring og referansebruk:</strong> Bruk på nettsider, i presentasjoner, salgs- og markedsføringsmateriell, sosiale medier og annen kommunikasjon.</p></li>
          <li><p><strong>c) Dokumentasjon og promotering:</strong> Bruk i investorpresentasjoner, presseomtale, bransjemateriale og annen legitim promotering.</p></li>
        </ul>
        <p>Samtykket gjelder så lenge laget/foreningen er registrert som aktiv bruker av tjenesten. Tilbaketrekking kan begjæres skriftlig og gjelder fremtidig bruk.</p>

        <p class="mt-4">Dokumentversjon: v1.3 – Oppdatert januar 2026</p>

        <h3 class="mt-5"><a href="../../../assets/legal/Terms-of-Use_Vilkar-for-bruk-HenterPant.pdf" download>Last ned fullstendig versjon av vilkårene (PDF)</a></h3>
      </div>
    </ng-container>


    <ng-container *ngIf="activeTab === ACTIVE_TAB.HENTERPANT && currentLang === 'en'">
      <p class="last-update">Last updated: January 2026 · Version 1.3</p>

      <div class="content" data-header-contrast="light">
        <h2>1. Introduction</h2>
        <p>These Terms of Use apply to users of the Henter Pant application, including teams, clubs, players and guardians. By using the service, you agree to be bound by these Terms.</p>
        <p>Gi Pant AS provides a digital platform that enables sports teams and school classes to collect bottle deposits as a source of income.</p>

        <h2>2. Roles</h2>
        <ul>
          <li>
            <p><strong>Team/Club/Organization (paying customer)</strong></p>
            <ul>
              <li><p>legal recipient of bottle deposit income</p></li>
              <li><p>recipient of invoices</p></li>
              <li><p>responsible for ensuring that players comply with these Terms</p></li>
            </ul>
          </li>
          <li>
            <p><strong>Team Administrator</strong></p>
            <ul>
              <li><p>creates and manages the team</p></li>
              <li><p>invites players</p></li>
              <li><p>has access to overviews of orders, receipts and team progress</p></li>
            </ul>
          </li>
          <li>
            <p><strong>Player</strong></p>
            <ul>
              <li><p>collects bottles</p></li>
              <li><p>registers collected amounts</p></li>
              <li><p>uploads deposit receipts</p></li>
              <li><p>complies with safety rules</p></li>
              <li><p>uses address-based pickup (not GPS tracking)</p></li>
            </ul>
          </li>
          <li>
            <p><strong>Guardian</strong></p>
            <ul>
              <li><p>required for players under the age of 15</p></li>
              <li><p>controls the child's account</p></li>
              <li><p>has full access and oversight</p></li>
              <li><p>may enable or disable GPS on their own device</p></li>
            </ul>
          </li>
          <li>
            <p><strong>Child</strong></p>
            <ul>
              <li><p>cannot have their own GPS enabled</p></li>
              <li><p>must be linked to an active guardian account</p></li>
            </ul>
          </li>
        </ul>

        <h2>3. Subscription and payment</h2>
        <ul>
          <li>
            <p><strong>3.1 Initial payment (Nets Easy)</strong></p>
            <ul>
              <li><p>The first payment is made via Nets Easy</p></li>
              <li><p>Successful payment is required to gain access to the service</p></li>
              <li><p>Failed payment results in no access</p></li>
            </ul>
          </li>
          <li>
            <p><strong>3.2 Ongoing payment (PowerOffice)</strong></p>
            <ul>
              <li><p>Invoiced monthly</p></li>
              <li><p>Includes subscription fee, commission/royalty and invoicing fees</p></li>
              <li><p>12 days payment deadline plus a 30-day grace period</p></li>
            </ul>
          </li>
          <li>
            <p><strong>3.3 Notice period</strong></p>
            <ul>
              <li><p>The notice period is three (3) months, calculated from the first day of the following calendar month</p></li>
              <li><p>The subscription remains active throughout the notice period. No refunds are provided for partially used months</p></li>
            </ul>
          </li>
          <li>
            <p><strong>3.4 Account termination</strong></p>
            <ul>
              <li><p>Gi Pant AS may suspend the team in the event of non-payment</p></li>
              <li><p>The team is not entitled to refunds for periods already invoiced</p></li>
            </ul>
          </li>
        </ul>

        <h2>4. Discounts and invitation codes</h2>
        <ul>
          <li><p><strong>Invitation codes:</strong> Teams inviting new teams may receive a discount; invited teams may receive a discount; discount rates may vary; discounts are applied on the next invoice via PowerOffice.</p></li>
          <li><p><strong>Combination with campaign codes:</strong> Invitation codes and campaign codes may be combined; applicable discounts are always displayed in the app prior to purchase.</p></li>
        </ul>

        <h2>5. Bottle collection</h2>
        <ul>
          <li>
            <p><strong>Team responsibility</strong></p>
            <p>The team, club or organization holds overarching responsibility for ensuring that bottle collection is conducted in accordance with these Terms. Suspected fraud, receipt manipulation, misuse of bottles or deposits, or other dishonest practices may lead to suspension of part or all of the team's access.</p>
          </li>
          <li>
            <p><strong>Player responsibilities</strong></p>
            <ul>
              <li><p>collect bottles at the agreed location</p></li>
              <li><p>deposit the bottles</p></li>
              <li><p>register the correct amount</p></li>
              <li><p>upload the receipt</p></li>
            </ul>
          </li>
          <li>
            <p><strong>Receipt discrepancies</strong></p>
            <ul>
              <li><p>Incorrect amounts are flagged; repeated discrepancies may result in suspension</p></li>
            </ul>
          </li>
          <li>
            <p><strong>Missing bags</strong></p>
            <ul>
              <li><p>The order is marked as "not found"</p></li>
              <li><p>The team may report the donor</p></li>
              <li><p>Repeated incidents may lead to donor exclusion</p></li>
            </ul>
          </li>
          <li>
            <p><strong>Sharing of profiles and order communication</strong></p>
            <p>Henter Pant provides functionality for sharing team profiles, player profiles and pickup orders via social media, messaging platforms and shareable links. Sharing is initiated by the user, and content may become accessible to third parties outside Henter Pant's control. Users are responsible for how and with whom content is shared; team administrators and guardians should guide players and children in safe use.</p>
          </li>
        </ul>

        <h2>6. GPS and location data</h2>
        <ul>
          <li>
            <p><strong>6.1 Players and children</strong></p>
            <ul>
              <li><p>players and children are never tracked</p></li>
              <li><p>only address-based location is used</p></li>
            </ul>
          </li>
          <li>
            <p><strong>6.2 Guardians</strong></p>
            <ul>
              <li><p>may choose to enable GPS to receive pickup requests</p></li>
              <li><p>GPS data is provided by the mobile operating system (iOS/Android), not the app</p></li>
              <li><p>update intervals are controlled by the operating system</p></li>
              <li><p>Gi Pant AS does not store continuous GPS data</p></li>
            </ul>
          </li>
          <li>
            <p><strong>6.3 Deletion of location data</strong></p>
            <ul>
              <li><p>GPS data is automatically deleted after a maximum of seven (7) days</p></li>
            </ul>
          </li>
          <li>
            <p><strong>6.4 Pause function</strong></p>
            <ul>
              <li><p>stops all GPS processing</p></li>
              <li><p>stops new orders</p></li>
              <li><p>stops notifications</p></li>
            </ul>
          </li>
        </ul>

        <h2>7. Misuse, suspension and exclusion</h2>
        <ul>
          <li>
            <p><strong>Grounds for suspension</strong></p>
            <ul>
              <li><p>incorrect receipt reporting</p></li>
              <li><p>handling of hazardous waste</p></li>
              <li><p>aggressive or threatening behavior</p></li>
              <li><p>technical manipulation</p></li>
              <li><p>fraud attempts</p></li>
            </ul>
          </li>
          <li>
            <p><strong>Team responsibility</strong></p>
            <ul>
              <li><p>the team is responsible for its players</p></li>
              <li><p>individual players may be suspended without suspending the entire team</p></li>
              <li><p>teams are suspended only in cases of non-payment or serious misconduct</p></li>
            </ul>
          </li>
          <li>
            <p><strong>Duration</strong></p>
            <ul>
              <li><p>suspension remains in effect until the matter is investigated</p></li>
              <li><p>typical duration: 7–30 days</p></li>
            </ul>
          </li>
          <li>
            <p><strong>Permanent exclusion</strong></p>
            <ul>
              <li><p>the account may be permanently closed for serious breach</p></li>
              <li><p>the player may be barred from creating a new account</p></li>
            </ul>
          </li>
        </ul>

        <h2>8. Safety and limitation of liability</h2>
        <p>Gi Pant AS is not liable for:</p>
        <ul>
          <li><p>injuries sustained by players during bottle collection</p></li>
          <li><p>contents of collected bags</p></li>
          <li><p>hazardous waste provided by donors</p></li>
          <li><p>losses resulting from incorrect registration by players</p></li>
          <li><p>delays or cancellation of orders</p></li>
        </ul>

        <h2>9. Privacy</h2>
        <p>Full information regarding the processing of personal data is available in the <a href="/{{currentLang}}/henter-pant/privacy-policy">Privacy Policy v1.2</a>.</p>

        <h2>10. Email communication</h2>
        <p>Gi Pant AS uses email as a communication channel to teams, clubs, organizations, team administrators and guardians as necessary for the operation, security and use of the service.</p>
        <h3>10.1 Service-related email</h3>
        <p>Cannot be opted out of and includes:</p>
        <ul>
          <li><p>order and status notifications</p></li>
          <li><p>receipts and confirmations</p></li>
          <li><p>notifications regarding deviations, suspension or security</p></li>
          <li><p>information about changes to the Terms or the service</p></li>
          <li><p>invoicing and payment-related communication, including notifications of issued invoices from the accounting system</p></li>
        </ul>
        <h3>10.2 Product information and service development</h3>
        <p>May be sent based on legitimate interest and always includes a simple opt-out option:</p>
        <ul>
          <li><p>tips and recommendations for improved use of the service</p></li>
          <li><p>information about new or enhanced features</p></li>
          <li><p>invitations to pilot programs, beta testing or new solutions</p></li>
        </ul>
        <h3>10.3 Recipients and role allocation</h3>
        <ul>
          <li><p>the team administrator is the primary recipient for team-related communication</p></li>
          <li><p>guardians are the primary recipients for children and player accounts</p></li>
          <li><p>players do not normally receive direct email communication during the MVP phase</p></li>
        </ul>

        <h2>11. Governing law and venue</h2>
        <p>Norwegian law applies.</p>
        <p>Legal venue: Salten and Lofoten District Court.</p>

        <h2>12. Use of name, logo and visual identifiers</h2>
        <p>By registering a club, team and/or organization and/or purchasing a subscription in Henter Pant, the club, team or organization grants Henter Pant AS a non-exclusive, royalty-free and perpetual right to use the club's, team's or organization's name, logo and other visual identifiers ("Logo") in the following contexts:</p>
        <ul>
          <li><p><strong>a) Use within the service:</strong> Display of the name and Logo within the Henter Pant application and related digital interfaces, including team profiles, pickup orders, overviews and donation flows.</p></li>
          <li><p><strong>b) Marketing and reference use:</strong> Use on Henter Pant AS websites, presentations, sales and marketing materials, social media and other communications identifying the club, team or organization as a customer or participant in the service.</p></li>
          <li><p><strong>c) Documentation and promotion:</strong> Use in investor presentations, press coverage, industry material and other legitimate promotion of Henter Pant AS and the service.</p></li>
        </ul>
        <p>The consent remains valid while the club, team or organization is an active user. Withdrawal of consent may be requested in writing and applies to future use only.</p>

        <p class="mt-4">Document version: v1.3 – January 2026</p>

        <h3 class="mt-5"><a href="../../../assets/legal/Terms-of-Use_Vilkar-for-bruk-HenterPant.pdf" download>Download the full version of the terms (PDF)</a></h3>
      </div>
    </ng-container>


  </div>
</section>
